export enum PinStatus {
  SUCCESS = 0,
  FAILED = 1,
  BLOCKED = 2,
}
